import { render, staticRenderFns } from "./OrganizationSwitcher.vue?vue&type=template&id=d20f6b30&"
import script from "./OrganizationSwitcher.vue?vue&type=script&lang=js&"
export * from "./OrganizationSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports